"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateMalformedLocalTransform = exports.migration_81_29_1 = void 0;
/**
 * Migrate to 81.29.1
 *
 * Tries to migrate malformed localtransforms
 */
const migration_81_29_1 = (json) => {
    var _a, _b;
    (_a = json.Leitungen) === null || _a === void 0 ? void 0 : _a.forEach(migrateMalformedLocalTransform);
    (_b = json.IAs) === null || _b === void 0 ? void 0 : _b.forEach(migrateMalformedLocalTransform);
    return json;
};
exports.migration_81_29_1 = migration_81_29_1;
function migrateMalformedLocalTransform(item) {
    const localTransform = item.LocalTransform;
    // not set? thats fine!
    if (!localTransform)
        return;
    // set and an array? great!
    if (Array.isArray(localTransform))
        return;
    // set, not an array and neither an object?
    if (typeof localTransform !== 'object') {
        // set to undefined
        item.LocalTransform = undefined;
        return;
    }
    const keys = Object.keys(localTransform);
    const idxKeys = ['0', '1', '2', '3', '4', '5'];
    // its an object but not formed like we would expect it?
    if (keys.length !== 6 || !idxKeys.every((k) => keys.includes(k) && !isNaN(localTransform[k]))) {
        // set to undefined
        item.LocalTransform = undefined;
        return;
    }
    // we got an object with six keys/values.. make it an array!
    const newLocalTransform = [];
    idxKeys.forEach((k) => {
        newLocalTransform.push(localTransform[k]);
    });
    item.LocalTransform = newLocalTransform;
}
exports.migrateMalformedLocalTransform = migrateMalformedLocalTransform;
//# sourceMappingURL=migration_81_29_1.js.map